export default function(value) {
    let bytes = parseInt(value);
    if (!bytes)
        return;

    let units = ['B', 'KB', 'MB', 'GB', 'TB'];

    let i;
    for (i = 0; bytes >= 1000 && i < units.length; i++)
        bytes /= 1024;

    let options = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };

    return bytes.toLocaleString(undefined, options) + ' ' + units[i];
}
